// extracted by mini-css-extract-plugin
export default {"title":"tab_title__9smO+","otpTitle":"tab_otpTitle__++5li","otpDescription":"tab_otpDescription__J8ryd"};